export const getPriceTable = state => state.priceTable;
